import React, { useState } from 'react';
import { Document, Page } from 'react-pdf';
import { LeftArrowSvg, RightArrowSvg } from '../../icons';
import { CustomButton, FormInput, GridItem } from '../../styles/styled';

type DocumentPdfProps = {
  file: string;
};

export const DocumentPdf = React.memo(function DocumentPdf({ file }: DocumentPdfProps) {
  const [maxPdfPages, setMaxPdfPages] = useState<number>(1);
  const [pageInput, setPageInput] = useState<number | null>(null);
  const [pdfPageState, setPdfPage] = useState<number>(1);

  return (
    <div>
      <div style={{ height: '500px', display: 'flex', justifyContent: 'center', alignItems: 'flex-start' }}>
        <Document onLoadSuccess={({ numPages }) => setMaxPdfPages(numPages)} file={{ url: file }} renderMode="canvas">
          <Page width={350} height={400} pageNumber={pdfPageState || 1} />
        </Document>
      </div>

      <GridItem direction="row" align="center" justify="center" gap="10px">
        <CustomButton
          padding="8px 10px"
          lined
          onClick={() => {
            if (pdfPageState > 1) setPdfPage(pdfPageState - 1);

            if (pageInput) setPageInput(null);
          }}
        >
          <div style={{ height: '15px' }}>
            <LeftArrowSvg />
          </div>
        </CustomButton>
        <FormInput
          type="number"
          onChange={(e) =>
            setPageInput(parseInt(e.target.value) > maxPdfPages ? maxPdfPages : parseInt(e.target.value))
          }
          width="90px"
          value={pageInput || pdfPageState}
        />
        <CustomButton
          width="400px"
          padding="5px 10px"
          lined
          flex
          onClick={() => {
            if (pdfPageState < maxPdfPages) setPdfPage(pageInput ? pageInput : pdfPageState + 1);

            if (pageInput) setPageInput(null);
          }}
        >
          перейти
          <div style={{ height: '15px' }}>
            <RightArrowSvg />
          </div>
        </CustomButton>
        <div className="text">из {maxPdfPages}</div>
      </GridItem>
    </div>
  );
});
